/**
 * Layout constants for consistent sizing across the application
 */

export const HEADER_HEIGHT = "3rem";
